
import React, { useState, useEffect } from 'react';
import '../Login/login.css'; 
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import LabelText from '../../ui/LabelText';
import LoginErrorIcon from '../../assets/icons/loginError.png';
import MFLoginLogo from '../../assets/images/MF_logo.png';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PrimaryButton from '../../ui/PrimaryButton';
import { useLoading } from '../../contexts/LoadingContext';
import LoadingSpinner from '../../ui/LoadingSpinner';
import { postData } from '../../services/api';
import apiUrls from '../../config/apiUrls';
import IApiResponse from '../../types/IApiResponse';

const ChangePassowrd = () => {

    const {userData} = useAuth();
    const navigate = useNavigate();
    const {startLoading , stopLoading , loading} = useLoading();
    const [newPassword, setNewPassword] = useState<string>('');
    const [oldpassword, setOldPassword]= useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');

    const [errorMsg , setErrorMsg] = useState<string>('')

    const [showOldPassword , setShowOldPassword]= useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPasseord, setShowConfirmPassword] = useState<boolean>(false);
    const [showFadeIn , setShowFadeIn] = useState<boolean>(false);

    const [passwordErrors, setPasswordErrors] = useState<string[]>([]);
    const [passwordChnage , setIsPasswordChange] = useState<boolean>(false)
    const [passwordMatch , setIsPassowrdMatch] = useState<string>('')
    
    const validatePassword = (value: string) => {
        const errors: string[] = [];
        if(value){
            if (!/[A-Z]/.test(value) || !/[a-z]/.test(value) || !/[0-9]/.test(value) || !/[!@#$%^&*(),.?":{}|<>]/.test(value) || value.length < 8) {
                errors.push("Password must contain 8 characters, include upper & lower case letters, a number, and a special character.");
            }
        }
        return errors;
    };

    const handleOldPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setOldPassword(value);
        // setPasswordErrors(validatePassword(value));
    };
    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setNewPassword(value);
        setPasswordErrors(validatePassword(value));
        if (confirmPassword !== value) {
            setIsPassowrdMatch('Password and Confirm Password do not match. Please try again.');
        }
        else{
            setIsPassowrdMatch('')
        }
    };
    const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setConfirmPassword(value);
        if (newPassword !== value) {
            setIsPassowrdMatch('Password and Confirm Password do not match. Please try again.');
        }
        else{
            setIsPassowrdMatch('')
        }
        // setPasswordErrors(validatePassword(value));
    };
    

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleShowOldPassword = () => {
        setShowOldPassword(!showOldPassword);
    };

     const handleSubmit = async () =>{
            try {
                startLoading();
              
                const requestParameters = {
                    userId: userData,
                    oldPassword: oldpassword,
                    newPassword: newPassword
                };
              
                const response: IApiResponse<any> = await postData(apiUrls["ChangePassword"], requestParameters);
                stopLoading(); 
                if (response?.isSuccess) {
                    setIsPasswordChange(true)
                    setErrorMsg('');
                  return { success: true, response };
                } else {
                  setErrorMsg(response.error.message)
                  return { success: false, response };
                }
              
              } catch (error) {
                console.error('Password reset failed:', error);
                stopLoading();
                return { success: false, response: error };
              }
              
        }

        const handleLogout = () =>{
            localStorage.clear()
            navigate('/login')
        }

    return (
        <>
            <div className="login-wrapper">
                <div className={showFadeIn ? 'login' : ''}></div>
            
                <div className="login-container" style={{padding:"40px"}}>
                    <div className="logo">
                        <img src={MFLoginLogo} alt="mc-football-logo" />
                    </div>
                    {passwordChnage ? (
                        <div className='signup-success-conatiner'>
                            <LabelText className='player-family-name' style={{color:'#54E0C5'}}>You have successfully updated your password.</LabelText>
                             <LabelText>Please {""}
                                            <a
                                              style={{ textDecoration: 'underline', color: 'black' }}
                                              onClick={handleLogout}
                                            >
                                              Log in
                                            </a>{' '}
                                            to access your account.
                                          </LabelText>
                                          <PrimaryButton
                                            className="login-button"
                                            label="Log in"
                                            onClick={handleLogout}
                                          />
                        </div>

                ):(
                    <form className="login-form" autoComplete="off">
                        <LabelText className='club-given-name'>Change Password</LabelText>
                        <div className="form-group">
                            <LabelText className='custom-list-text'>Old Password</LabelText>
                            <div className="input-container">
                                <input
                                    type={showOldPassword ? "text" : "password"}
                                    name="password"
                                    placeholder='Enter your password'
                                    autoComplete="off"
                                    value={oldpassword}
                                    onChange={handleOldPasswordChange}
                                />
                                {oldpassword &&(
                                    <span className="custom-icon" onClick={toggleShowOldPassword}>
                                        {showOldPassword ? <VisibilityIcon/> : <VisibilityOffIcon />}
                                    </span>
                                )}
                            </div>
                        {/* {passwordErrors && <LabelText className='error-text'>{passwordErrors}</LabelText>} */}
                        </div>
                        <div className="form-group">
                            <LabelText className='custom-list-text'>New Password</LabelText>
                            <div className="input-container">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder='Enter your password'
                                    autoComplete="off"
                                    value={newPassword}
                                    onChange={handlePasswordChange}
                                />
                                {newPassword &&(
                                    <span className="custom-icon" onClick={toggleShowPassword}>
                                        {showPassword ? <VisibilityIcon/> : <VisibilityOffIcon />}
                                    </span>
                                )}
                            </div>
                        {passwordErrors && <LabelText className='error-text'>{passwordErrors}</LabelText>}
                        </div>
                        <div className="form-group">
                            <LabelText className='custom-list-text'>Confirm Password</LabelText>
                            <div className="input-container">
                                <input
                                    type={showConfirmPasseord ? "text" : "password"}
                                    name="password"
                                    placeholder='Enter confirm password'
                                    autoComplete="off"
                                    value={confirmPassword}
                                    onChange={handleConfirmPasswordChange}
                                />
                                {confirmPassword &&(
                                    <span className="custom-icon" onClick={()=>{setShowConfirmPassword(!showConfirmPasseord)}}>
                                        {showConfirmPasseord ? <VisibilityIcon/> : <VisibilityOffIcon />}
                                    </span>
                                )}
                            </div>
                            {passwordMatch && (<LabelText className='error-text'>{passwordMatch}</LabelText>)}
                        </div>
                        
                    </form>
                           )} 
                    {errorMsg &&(
                        <div className='error-container'>
                            <img src={LoginErrorIcon}/>
                            <LabelText className='error-text'>{errorMsg ? errorMsg : ''}</LabelText>
                        </div>
                    )}
                    
                    {!passwordChnage &&(
                        <>
                        <div className="form-actions">
                            <PrimaryButton className="login-button" label="Submit" onClick={handleSubmit}
                            disabled={oldpassword === '' || newPassword === '' || confirmPassword === '' || passwordMatch !== '' || passwordErrors === null}/>
                        </div>
                        </>
                    )} 
                    
                </div>
            </div>
            {loading && <LoadingSpinner />}
        </>
    );
};

export default ChangePassowrd;
